export class ResponseEstadoGeneralModel{
    payload:EstadoGeneralModel;

    constructor(){
        this.payload = new EstadoGeneralModel();
    }
}

export class EstadoGeneralModel{    
    idTablaMaestra:number;
    descripcionCorta:string;
    descripcionLarga:string;
    constructor(){
        this.idTablaMaestra = -1;
        this.descripcionCorta = "";
        this.descripcionLarga = "";

    }
}

